exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".spinner--17uiQ {\r\n\tbackground: #4267b2 !important;\r\n\tmargin-top: 10px !important;\r\n\tborder-radius: 4px !important;\r\n}", ""]);

// Exports
exports.locals = {
	"spinner": "spinner--17uiQ"
};